module.exports = __webpack_public_path__ + "static/media/m-white.0be480f5.png";